<template>
	<div class="special-instructions-text-container">
		<BaseResizeableTextArea
			@input="updateSpecialInstructionText"
			:inputVal="userInstructions"
			classNames="input special-instructions-input text-input" 
			placeHolder="Enter additional notes for your order here"
			ariaLabel="Enter any special notes for your order here"/>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex';
	import { ACCOUNT_CHECKOUT } from '@/stores/defs';
	
	const characterLimit = 512;

	export default {
		computed: {
			...mapGetters({
				userInstructions: ACCOUNT_CHECKOUT.GET_USER_INSTRUCTIONS
			})
		},
		methods: {
			...mapActions({
				setUserInstructions: ACCOUNT_CHECKOUT.SET_USER_INSTRUCTIONS
			}),
			handleOnChange(event) { 
				const inputText = event.target.value;
				this.updateSpecialInstructionText(inputText);
			},
			updateSpecialInstructionText(text) {
				if (text.length > characterLimit) {
					text = text.substring(0, characterLimit);
					this.$refs.specialInstructions.value = text;
				}
				this.setUserInstructions(text);
			}
		},
		mounted() {
			if (this.userInstructions) {
				this.value = this.userInstructions;
			}
		}
	}
</script>

<style lang="scss">
	@import 'globalStyles';
	.special-instructions-text-container {
		flex: 5;
	}
	.special-instructions-input {
		resize: none;
	}
	@include desktop {}
	@include mobile {
		.minimal {
			.special-instructions-input {
				margin: 0 20px;
				width: calc(100% - 40px);
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/checkout/CheckoutSpecialInstructions.vue